<template>
  <div v-if="dialogVisible" class="agreementModal">
    <div class="container">
      <h4 class="text-center">《入学协议告知书》</h4>
      <p class="title">
        本告知书由深圳市灵动量教育培训中心有限公司与您共同缔结，您通过所购买的质心灵动量课程入口阅读本告知书，点击“同意”按钮即视为您充分阅读并理
        解本告知书内全部内容并签署本协议，您同意遵守本告知书内全部内容及规范要求。
      </p>
      <p class="title">一、深圳市灵动量教育培训中心有限公司教辅人员权利和义务</p>
      <p>1、 深圳市灵动量教育培训中心有限公司教辅人员负责为您提供教学课程、讲义、学习资料等；</p>
      <p>2、 深圳市灵动量教育培训中心有限公司教辅人员负责对教学设备、设施的维护，保证教学的正常开展；</p>
      <p>3、深圳市灵动量教育培训中心有限公司教辅人员负责按课程规定实施教学，完成教学；</p>
      <p>4、深圳市灵动量教育培训中心有限公司教辅人员有权要求您上课期间应遵守学校的各项纪律及管理要求；</p>
      <p>5、深圳市灵动量教育培训中心有限公司教辅人员有义务对您在纪律及学习成绩方面的管理及考核</p>
      <p class="title">二、您权利和义务</p>
      <p>1、您有权获取深圳市灵动量教育培训中心有限公司教辅人员承诺的学习内容，包括理论和实际操作技能；</p>
      <p>2、您有权向深圳市灵动量教育培训中心有限公司教辅人员提出合理化意见，经深圳市灵动量教育培训中心有限公司教辅人员认可后，可采纳执行；</p>
      <p>
        3、您有义务配合深圳市灵动量教育培训中心有限公司教辅人员，按照深圳市灵动量教育培训中心有限公司教辅人员的规章制度、教学大纲完成其所选课程；
      </p>
      <p>4、严禁您向深圳市灵动量教育培训中心有限公司教辅人员领导、讲师及其他工作人员送礼和宴请；</p>
      <p>5、您对深圳市灵动量教育培训中心有限公司教辅人员的行政、管理有建议和监督权；</p>
      <p>6、您应严格遵守国家的法律法规、社会公德和深圳市灵动量教育培训中心有限公司教辅人员的教学管理规定及《入学协议告知书》所述内容；</p>
      <p>7、您在学习期间应努力学习、刻苦钻研，熟练掌握所学知识；</p>
      <p>8、您需按深圳市灵动量教育培训中心有限公司教辅人员要求完成作业、实验及设计作品等；</p>
      <p>9、在深圳市灵动量教育培训中心有限公司教辅人员的工作时间内，您有权请教师为其答疑和辅导其学习</p>
      <p class="title">三、 退费须知</p>
      <p>
        若对课程不满意或其他个人原因需要退费的，需提供相关证明，同时带上收费凭证，按规定联系深圳市灵动量教育培训中心有限公司教辅人员执行退费流程。
      </p>
      <p>退费金额=已缴费用-已耗全额课时费-教材费（小于等于 200 元的低价课不接受退费。）</p>
      <p class="title">四、 您完成所选课程后本告知书自然终止</p>
      <p class="text-center btn">
        <el-button style="width: 180px" type="primary" @click="closeFloating">返 回</el-button>
      </p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'EntranceAgreement',
  data () {
    return {
      dialogVisible: false
    }
  },
  methods: {
    showFloating () {
      this.dialogVisible = true
    },
    closeFloating () {
      this.dialogVisible = false
    }
  }
}
</script>
<style lang="scss">
  .agreementModal {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: #fff;
    overflow: scroll;
    z-index: 99999;
    text-align: left;
    color: rgba(51, 51, 51, .6);;
    font-size: 14px;
    line-height: 1.4;
    > div {
      padding: 20px;
      width: auto;
      h4 {
        color: rgba(51, 51, 51, 1);
        font-size: 18px;
        font-weight: 500;
        margin-bottom: 10px;
      }
      P {
        margin-bottom: 10px;
        &.title {
          color: rgba(51, 51, 51, 1);
          margin-top: 20px;
        }
        button {
          width: 180px;
          margin-top: 10px;
          font-size: 16px;
          font-weight: 500;
        }
      }
    }
  }
</style>
